import useLocalStorage from '../../hooks/useLocalStorage';
import { ButtonComponent } from '../UI/ButtonComponent/ButtonComponent';
import { useNavigate } from 'react-router';
import './HubBanner.scss';
import { PROFILE_ROUTES } from '../../common/constants';
import { useState } from 'react';

export const HubBanner = () => {
	const [showBanner, setShowBanner] = useLocalStorage('hub-banner', true);
	const [isClosed, setIsClosed] = useState(false);
	const navigate = useNavigate();
	const handleClick = () => {
		setShowBanner(false);
		setIsClosed(true);
		navigate('/' + PROFILE_ROUTES.BRAND_INFO);
	};
	const handleClose = () => {
		setShowBanner(false);
		setIsClosed(true);
	};

	if (!showBanner || isClosed) return null;
	return (
		<>
			<div className='hub-banner-container'>
				<h3 className='title-banner-mobile' onClick={handleClick}>
					NEW! Update Your Brand’s Information In Seconds With The Beacon Hub
				</h3>
				<div className='img-hub-container' onClick={handleClick}></div>
				<div className='content-hub-container' onClick={handleClick}>
					<h3 className='title-banner'>
						NEW! Update Your Brand’s Information In Seconds With The Beacon Hub
					</h3>
					<div className='hub-content-description'>
						<span className='description-banner'>
							Access 'My Beacon Hub' in your user profile now.
						</span>
						<ButtonComponent
							style='rounded-button primary'
							onClick={handleClick}
							icon={<i className='ri-arrow-right-s-line line-icon'></i>}
							text='Try It Out'
						></ButtonComponent>
					</div>
				</div>
				<ButtonComponent
					style='rounded-button tertiary'
					onClick={handleClose}
					text=''
					iconOnly
					icon={<i className='ri-close-line line-icon'></i>}
				></ButtonComponent>
			</div>
		</>
	);
};
